import { MessageBody } from "../style";

const URL_PATTERN = /(https?:\/\/[^\s<>"']+)/gi;
const TRAILING_PUNCTUATION = /[.,;:!?)\]]+$/;

/**
 * Тело сообщения — плоский текст: React экранирует его сам, переносы сохраняет white-space: pre-wrap,
 * ссылки http(s) становятся кликабельными (rel=noopener). HTML не интерпретируется.
 */
const SupportMessageText = ({ text }) => {
  if (!text) return null;

  const parts = String(text).split(URL_PATTERN);

  return (
    <MessageBody>
      {parts.map((part, index) => {
        if (index % 2 === 0) return part;

        const tail = (part.match(TRAILING_PUNCTUATION) || [""])[0];
        const url = tail ? part.slice(0, -tail.length) : part;

        return (
          <span key={index}>
            <a href={url} target="_blank" rel="noopener noreferrer nofollow">
              {url}
            </a>
            {tail}
          </span>
        );
      })}
    </MessageBody>
  );
};

export default SupportMessageText;
